import React from "react";

export type CenterClickDeps = {
  videoRefs: any; // supports both object map and ref.current map
  iconTimers: React.MutableRefObject<Record<string, number | null>>;
  setPlayingMap: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  setIconVisibleMap: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
};

function getVideoElFromRefs(videoRefs: any, id: string): HTMLVideoElement | null {
  if (!videoRefs) return null;
  if (videoRefs[id]) return videoRefs[id] as HTMLVideoElement | null;
  if (videoRefs.current && videoRefs.current[id]) return videoRefs.current[id] as HTMLVideoElement | null;
  return null;
}

export function createCenterClickHandler({
  videoRefs,
  iconTimers,
  setPlayingMap,
  setIconVisibleMap,
}: CenterClickDeps) {
  return async (id: string) => {
    const v = getVideoElFromRefs(videoRefs, id);
    if (!v) return;
    try {
      if (v.paused) {
        await v.play();
        setPlayingMap((p) => ({ ...p, [id]: true }));
        setIconVisibleMap((p) => ({ ...p, [id]: false }));
        if (iconTimers.current[id]) {
          window.clearTimeout(iconTimers.current[id]!);
          iconTimers.current[id] = null;
        }
      } else {
        v.pause();
        setPlayingMap((p) => ({ ...p, [id]: false }));
        setIconVisibleMap((p) => ({ ...p, [id]: true }));
        if (iconTimers.current[id]) {
          window.clearTimeout(iconTimers.current[id]!);
        }
        iconTimers.current[id] = window.setTimeout(() => {
          setIconVisibleMap((p) => ({ ...p, [id]: false }));
          iconTimers.current[id] = null;
        }, 1500);
      }
    } catch (e) {
      // ignore play/pause exceptions (browser policies)
    }
  };
}